module.exports = __webpack_public_path__ + "img/goal-twelve-br.cb99c635.png";